// library imports
import "react-multi-carousel/lib/styles.css";
import Testimonials from "../Views/Home/_components/Testimonials";

const UserReviews = () => {
   return (
      <>
         <Testimonials />
      </>
   );
};

export default UserReviews;
